<template>
    <b-modal
        :id="'product-info-modal' + product.ASIN"
        class="main-modal"
        ref="showEnterSuccessModal"
        size="md"
        ok-only
        :ok-title="'Done'"
    >
        <div slot="modal-header-close">
            (Times)
        </div>

        <div class="d-block">

            <div class="row">
                <div class="col-md-12">
                    <b-list-group>
                        <b-list-group-item
                            v-for="(value, key) in product.ItemAttributes"
                            :key="key"
                            v-if="value"
                        >
                            {{key}}:
                            <span
                                v-if="Array.isArray(value) || value instanceof Object"
                                v-for="(extra, i) in value"
                                :key="extra + i"
                            >
                                <br>- {{extra}}
                            </span>
                            <span
                                v-if="!Array.isArray(value) && !(value instanceof Object)"
                            >{{value}}</span>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'product-info-modal',
    props: {
        product: {
            type: Object,
            required: true
        },
    },
    data () {
        return {
        }
    },
    methods: {
    },
    mounted () {
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';
</style>
